<template>
    <div id="body">
        <div id="content">
            <div id="content-inner">
                <rkm-overlay
                    :opacity="1"
                    :show="loading"
                >
                    <div class="login-container">
                        <div v-show="!loading">
                            <rkm-col class="login-aside">
                                <div class="wallpaper">
                                    <div class="aside-content">
                                        <div class="aside-title">
                                            Sistema para cadastro de cidadão
                                        </div>
                                        <div class="aside-city">
                                            {{cliente && cliente.nome}}
                                        </div>
                                    </div>
                                </div>
                            </rkm-col>
                            <rkm-col class="login-right">
                                <div class="login-header">
                                    <img
                                        :alt="cliente && cliente.nome"
                                        :src="cliente && cliente.logotipo ? require(`@/assets/images/logotipos/${cliente.logotipo}`) : null"
                                        width="150"
                                    />
                                </div>

                                <slot />
                            
                                <div class="login-footer">
                                </div>
                            </rkm-col>
                        </div>
                    </div>
                </rkm-overlay>
            </div>
        </div>
    </div>
</template>

<script>
// Vuex.
import {mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({cliente: 'getCliente'}),
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('autenticacao')
        },
    },
}
</script>

<style scoped>
.login-container {    
    background-color: white;
    display: flex;
    height: 100vh;
}
.login-container > div {
    background-blend-mode: multiply;
    background-position: center center;
    background-size: cover;
    background: var(--primary) url('./../assets/images/login/wallpaper.jpg');
    box-shadow: -10px 0px 70px -80px rgb(0 0 0 / 50%) inset;
    display: flex;
    height: 100vh;
    justify-content: space-evenly;
    width: 100vw;
}
.login-container:before {
    background: rgba(0,0,0,0.6);
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;
}
.login-aside {
    align-items: center;
    display: flex;
    flex: 0 1 auto;
    height: 100%;
    justify-content: center;
    margin: 0;
    padding: 0;
    width: 450px;
}
.aside-actions .btn {
    background: rgb(255 255 255 / 21%);
    border-radius: 0.25rem;
    border: none;
    color: #FFF;
    font-size: 0.8rem;
    font-weight: 500;
    height: auto;
    padding: 0.5rem;
    position: relative;
    text-transform: uppercase;
}
.aside-title {
    font-size: 1.2rem;
    font-weight: 600;
}
.aside-city {
    font-size: 4.5rem;
    font-weight: 100;
    line-height: 1;
}
.aside-content {
    text-align: center;
}
.aside-actions {
    display: none;
}
.wallpaper {
    align-items: center;
    color: #FFF;
    display: flex;
    flex: 1;
    font-size: 2rem;
    height: 100%;
    justify-content: center;
    line-height: 1.2;
    text-shadow: 0.5px 0.5px #282a2c;
}
.login-right {
    align-items: center;
    align-self: start;
    background: #FFF;
    border-radius: 2rem;
    display: flex;
    flex-direction: column;
    flex: 0 1 auto;
    height: calc(100% - 6rem);
    justify-content: space-between;
    margin: 3rem 0;
    padding: 0;
    width: 35vw;
}
#body >>> .login-right > * {
    width: 100%;
}
.login-header {
    padding: 30px 10px;
    text-align: center;
    width: 100%;
}
.login-footer {
    background: rgba(0,0,0,0.04);
    border-top: 1px solid rgba(0,0,0,0.07);
    padding: 45px 5px;
    text-align: center;
    width: 100%;
}
.login-footer .btn {
    background: none;
    border: none;
    color: var(--gray);
    padding: 1rem 1.5rem;
}
.btn svg {
    margin-right: 5px;
}
#body >>> .login-form h1 {
    color: #6c757d;
    font-size: 1.8rem;
    font-weight: 400;
    line-height: 1;
    margin-bottom: 2rem;
}
#body >>> .login-form h1 span {
    color: var(--primary);
    font-weight: 200;
    letter-spacing: 0px;
    text-transform: initial;
}
#body >>> .login-form-actions .btn[type="submit"] {
    border-radius: 100px;
    height: auto;
    height: auto;
    padding: 0.7rem;
    width: 100%;
    width: 100%;
}
#body >>> .login-form-actions a {
    background: none;
    border: none;
    box-shadow: none;
    color: var(--gray);
    display: block;
    margin: 0.5rem 0 0 0;
    text-align: center;
}
#body >>>  .login-form {
    padding: 0 60px;
}
#body >>> h5 {
    font-size: 17px;
}
#body >>> h6 {
    font-size: 12px;
    opacity: 0.5;
    margin: 6px 0 0 0;
}
</style>